import Exif from './exif';

class PreviewImage {
  constructor(fileFieldSelector, previewSelector) {
    const $fileFieldSelector = $(fileFieldSelector);
    const $previewSelector = $(previewSelector);
    if ($fileFieldSelector.length < 1 && $previewSelector.length < 1) return;

    const { exifEnabled } = $fileFieldSelector.get(0).dataset;

    $fileFieldSelector.on('change', function (e) {
      const [file] = e.target.files;
      if (!file) return;

      if (exifEnabled === 'true') {
        new Exif(file, window?.I18n?.exif ?? {}).createPreviewRender();
      }

      const reader = new FileReader();
      reader.onload = function () {
        $previewSelector.html(`<img src="${this.result}">`);
      };
      reader.readAsDataURL(file);
    });
  }
}

export { PreviewImage };
